import * as React from 'react'
import './ContactForm.scss'
import { sendEmail } from '../../store/contact/actions'
import { ContactState, ContactData } from '../../store/contact/types';
//import { Dispatch } from 'redux'
import { connect } from 'react-redux'

interface PropsFromState {
  contact: ContactState;
}

interface PropsFromDispatch {
  sendEmail: typeof sendEmail
}

type AllProps =  PropsFromState & PropsFromDispatch;

const ContactForm: React.SFC<AllProps> = ({sendEmail, contact}) => {

    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      const formData = new FormData(event.currentTarget);
     // console.log("handleSubmit")
      sendEmail({name: formData.get('name') as string, email: formData.get('email') as string, message: formData.get('message') as string})


  };

  return (
    <div className="container">
      <form className="contactForm" onSubmit={handleSubmit}>
        <p className="name-field">
          <label htmlFor="name">Name</label>
          <input type="text" name="name" id="name" required />
        </p>
        <p className="email-field">
          <label htmlFor="email">Email</label>
          <input type="email" name="email" id="email" required />
        </p>
        <p className="message-field full">
          <label htmlFor="message">Message</label>
          <textarea name="message" rows="5" id="message" />
        </p>
        <p className="required-field">
          Required field <span>*</span>
        </p>
        <p className="submit-button">
          <button type="submit">Submit</button>
        </p>
      </form>
 {contact.loading && <p>Sending email...</p>}
      {contact.sent && <p>Email sent successfully!</p>}
      {contact.errors && <p>An error occurred while sending the email.</p>}
    </div>
  );
}

const mapStateToProps = (state: any): PropsFromState => ({
  contact: state.contact,
});

const mapDispatchToProps: PropsFromDispatch = {
  sendEmail,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContactForm);
